import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import Overline from "@/components/Overline";
import { company, seo, buildQuoteUrl } from "@/config/site";

const FACILITY_IMAGE =
  "https://images.unsplash.com/photo-1785228916052-34697b3325d5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHxpbmR1c3RyaWFsJTIwbWFudWZhY3R1cmluZyUyMGZhY2lsaXR5fGVufDB8fHx8MTc4ODA4MjE3NXww&ixlib=rb-4.1.0&q=85";

export default function About() {
  return (
    <>
      <SEO
        title="About Rudraksh Corrugation Solutions"
        description={`Established in ${company.establishedYear}, ${company.fullCompanyName} supplies packaging products across corrugated, PP, protective packaging, accessories and pallets. Greater Noida, India.`}
        canonical={`${seo.siteUrl}/about`}
      />
      <section className="border-b border-neutral-200 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
          <Overline>About</Overline>
          <h1 className="font-heading mt-4 text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-neutral-900">
            About {company.fullCompanyName}
          </h1>
          <p className="mt-6 max-w-3xl text-neutral-600 leading-relaxed">
            Established in {company.establishedYear} and based in Greater Noida, Uttar Pradesh, {company.fullCompanyName} supplies packaging products across corrugated, PP and protective packaging categories, alongside pallets, packaging accessories and materials.
          </p>
        </div>
      </section>

      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="relative aspect-[4/5] border border-neutral-200 overflow-hidden">
              <img src={FACILITY_IMAGE} alt="Industrial facility" className="absolute inset-0 h-full w-full object-cover" loading="lazy" />
            </div>
          </div>
          <div className="lg:col-span-7 space-y-6 text-neutral-600 leading-relaxed">
            <div>
              <div className="text-[11px] uppercase tracking-[0.2em] text-[#A91D22] font-bold">What we offer</div>
              <p className="mt-3">
                Our portfolio spans corrugated boxes and mono cartons, PP bins and boxes, protective packaging materials such as EPE foam fitments, bubble rolls, anti-static bags, humidity indicators, silica gel and activated carbon; packaging accessories including stretch film, strapping rolls, paper edge protectors and angle boards; and pallets in both plastic and wooden variants.
              </p>
            </div>
            <div>
              <div className="text-[11px] uppercase tracking-[0.2em] text-[#A91D22] font-bold">Working around your requirement</div>
              <p className="mt-3">
                Packaging requirements vary widely. We work around customer-specified dimensions, quantities and application context to identify the appropriate product.
              </p>
            </div>
            <div>
              <div className="text-[11px] uppercase tracking-[0.2em] text-[#A91D22] font-bold">Location</div>
              <p className="mt-3">{company.addressFull}</p>
            </div>
            <div>
              <a href={buildQuoteUrl()} target="_blank" rel="noopener noreferrer" className="inline-flex items-center bg-[#A91D22] text-white px-6 py-3 text-sm font-medium hover:bg-[#8B181C] rounded-sm">
                Request a Quote
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="py-14 bg-[#F5F5F5] border-y border-neutral-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {[
              { label: "Corrugated Packaging", to: "/products?cat=Corrugated%20Packaging" },
              { label: "PP Packaging", to: "/products?cat=PP%20Packaging" },
              { label: "Protective Packaging", to: "/products?cat=Protective%20Packaging" },
              { label: "Pallets & Accessories", to: "/products" },
            ].map((c) => (
              <Link key={c.label} to={c.to} className="bg-white border border-neutral-200 px-5 py-6 hover:border-[#A91D22] transition-colors">
                <div className="text-[11px] uppercase tracking-[0.18em] text-[#A91D22] font-bold">Category</div>
                <div className="mt-2 font-heading text-lg font-semibold text-neutral-900">{c.label}</div>
              </Link>
            ))}
          </div>
          <div className="mt-6">
            <Link to="/products" className="text-sm font-medium text-neutral-900 hover:text-[#A91D22]">
              View our products →
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
